import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  getProductionTypes,
  selectProductionTemplates
} from 'store/v1/productions/productions.selectors.js';

import {
  RadioGroup,
  Radio,
  PageTabs,
  ErrorMessage
} from 'v1/components/shared';

import { generateProductionFromTemplate } from 'v1/helpers/productionHelper';

import get from 'lodash/get';

import './ProductionTemplateSelect.scss';

const ProductionTemplateSelect = ({
  onProductionUpdate,
  production,
  error,
  onErrorClear
}) => {
  const productionTypes = useSelector(getProductionTypes);
  const [selectedProductionTypeId, setSelectedProductionTypeId] = useState(
    production.production_type_id
  );
  const productionTemplates = useSelector(state =>
    selectProductionTemplates(state, {
      production_type_id: selectedProductionTypeId
    })
  );

  const handleTemplateChange = event => {
    if (onErrorClear) {
      onErrorClear();
    }
    const selectedTemplateId = parseInt(event.target.value, 10);
    const selectedTemplate = productionTemplates.find(
      t => t.id === selectedTemplateId
    );
    if (selectedTemplate) {
      const updatedProduction = generateProductionFromTemplate(
        selectedTemplate,
        production
      );
      onProductionUpdate(updatedProduction, 'details');
    }
  };

  const getTemplateDisplayValue = template => {
    const icon =
      get(template, 'default_values.icon.value') ||
      get(template, 'default_values.icon');
    return icon ? `${icon} ${template.name}` : template.name;
  };

  return (
    <div className="ProductionTemplateSelect">
      <PageTabs
        tabs={
          productionTypes &&
          productionTypes.map(productionType => ({
            text: productionType.name,
            container: productionType.id
          }))
        }
        activeContainer={selectedProductionTypeId}
        onTabSelect={container => setSelectedProductionTypeId(container)}
        className="PageTabs_borderBottom"
      />
      <div className="inset-L">
        {productionTemplates.length > 0 && (
          <RadioGroup
            name="production-template"
            value={
              production.production_template_id
                ? String(production.production_template_id)
                : ''
            }
            onChange={handleTemplateChange}
          >
            {productionTemplates.map(template => (
              <Radio
                key={template.id}
                id={`template-${template.id}`}
                value={String(template.id)}
                label={getTemplateDisplayValue(template)}
              />
            ))}
          </RadioGroup>
        )}
        {error && <ErrorMessage appearance="text">{error}</ErrorMessage>}
      </div>
    </div>
  );
};

ProductionTemplateSelect.propTypes = {
  onProductionUpdate: PropTypes.func.isRequired,
  production: PropTypes.object,
  error: PropTypes.string,
  onErrorClear: PropTypes.func
};

export default ProductionTemplateSelect;
